import { render, staticRenderFns } from "./EditEventProcessingPage.vue?vue&type=template&id=9c15480e"
import script from "./EditEventProcessingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditEventProcessingPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports